import SingleProduct from "components/utils/SingleProduct";
import { products } from "utils/constants/constants";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useScreenSize } from "utils/hooks/useScreenSize";
import Button from "components/utils/Button";
import { ButtonSize, Color } from "utils/types/util.types";
import { useTranslation } from "react-i18next";

function PopularProducts() {

	const screenSize = useScreenSize();

	const { t } = useTranslation()

	return (
		<div className="mt-28 container">
			<div className="text-xl xs:text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-medium text-center">
				<span className="mr-3 text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-purple-600">{ t("mainPage.popularProducts.title.part1") }</span>
				<span className="text-gray-900">{ t("mainPage.popularProducts.title.part2") }</span>
			</div>
			<div className="text-center text-gray-700 text-xs xs:text-base md:text-lg font-normal my-5 md:my-10">
				{ t("mainPage.popularProducts.description") }
			</div>
			<div className="hidden lg:grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
				{ products.map((product, index) => index < 3 && <SingleProduct textId={ product.textId } key={ product.id } product={ product }/>) }
			</div>
			<div className="block lg:hidden grid-cols-1 md:grid-cols-3 gap-10">
				<Swiper
					spaceBetween={ 50 }
					modules={ [ Pagination, Autoplay ] }
					slidesPerView={ screenSize.width > 640 ? 2 : 1 }
					pagination={ { clickable: true } }
					autoplay={ { delay: 2000, pauseOnMouseEnter: true } }
					loop={ true }
				>
					{
						products.map((product, index) =>
							index < 3
								&&
								<SwiperSlide key={ index }>
									<SingleProduct textId={ product.textId } key={ product.id } product={ product }/>
								</SwiperSlide>,
						)
					}
				</Swiper>
			</div>
			<Button
				color={ Color.EMERALD }
				link="/products"
				className="block text-center mx-auto mt-16 sm:mt-12 sm:max-w-max"
				size={ ButtonSize.SMALL }
			>
				{ t("mainPage.popularProducts.seeAllProductsButtonText") }
			</Button>
		</div>
	);
}

export default PopularProducts;